/**
 * 上传相关
 */
import axios from "../../utils/axios";

// 获取七牛上传 upToken
export function qiNiuUpToken(query) {
    return axios({
        url: "/admin/upload/qiNiuUpToken",
        method: "get",
        params: query
    });
}

// 上传文件
export function createFile(url, formdata) {
    return axios({
        url: "/admin/upload/file",
        method: "post",
        data: formdata
    });
}
